import styled from 'styled-components'

// The sample schedule form, mirroring the fields of the signed-in scheduler.

export const StyledFormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--m-spacing-4);

  @media screen and (max-width: 640px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const StyledFormField = styled.div<{ $span?: number }>`
  display: flex;
  flex-direction: column;
  gap: var(--m-spacing-2);
  grid-column: span ${({ $span }) => $span ?? 1};

  @media screen and (max-width: 640px) {
    grid-column: span 1;
  }
`

export const StyledFormLabel = styled.label`
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-2);
  font-weight: var(--m-font-weight-medium);
  color: rgb(var(--m-color-text-secondary));
`

export const StyledSelect = styled.select`
  height: 40px;
  width: 100%;
  padding: 0 var(--m-spacing-3);
  box-sizing: border-box;
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-3);
  color: rgb(var(--m-color-text-primary));
  background-color: rgb(var(--m-color-background-primary));
  border: var(--m-border-thin) solid rgb(var(--m-color-border-input));
  border-radius: var(--m-border-radius-s);

  &:focus-visible {
    outline: 2px solid rgb(var(--m-color-brand));
    outline-offset: 1px;
  }
`

export const StyledCreatedNote = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--m-spacing-3);
  padding: var(--m-spacing-4) var(--m-spacing-5);
  border-top: var(--m-border-thin) solid rgb(var(--m-color-border));
  background-color: rgb(var(--m-color-background-highlight));
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-3);
  line-height: var(--m-line-height-6);
  color: rgb(var(--m-color-primary-100));
`

export const StyledCreatedMarker = styled.span`
  flex: 0 0 auto;
  margin-top: 2px;
  color: rgb(var(--m-color-success-100));
`

// Sits mid-sentence in the created-schedule note, so it is a link, not a button.
export const StyledInlineAction = styled.button`
  display: inline-flex;
  align-items: center;
  gap: var(--m-spacing-1);
  padding: 0;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  font-weight: var(--m-font-weight-bold);
  color: rgb(var(--m-color-text-link));
  background: none;
  border: none;
  text-decoration: underline;

  &:focus-visible {
    outline: 2px solid rgb(var(--m-color-brand));
    outline-offset: 2px;
  }
`
